import css from "./ChoseCarPopup.module.css";
import { BsCheck } from "react-icons/bs";
import { SiTicktick } from "react-icons/si";
import { RxCross1 } from "react-icons/rx";
import { IoCar } from "react-icons/io5";
import { useEffect, useRef, useState } from "react";

export default function ChoseCarPopup({
  onClose,
  isOpen,
  buttonRef,
  cars,
  setFieldValue,
}) {
  const popupRef = useRef(null);
  const [chosenCarId, setChosenCarId] = useState(null);

  const handleClickOutside = event => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleChooseCar = e => {
    e.stopPropagation();
    if (chosenCarId !== null) {
      const selectedCar = cars.find(car => car.id === chosenCarId);
      if (selectedCar && setFieldValue) {
        setFieldValue("car_number", selectedCar.plate || "");
        setFieldValue("vin", selectedCar.vin || "");
        setFieldValue("make", selectedCar.make || "");
        setFieldValue("model", selectedCar.model || "");
        setFieldValue("year", selectedCar.year || "");
      }
    }
    onClose();
  };

  const getStableColor = key => {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    return "#" + (hash >>> 0).toString(16).padStart(6, "0").slice(0, 6);
  };

  return (
    <div className={css.wrapper} ref={popupRef}>
      {chosenCarId !== null && (
        <div className={css.btnsBox}>
          <button
            type="button"
            className={`${css.btns} ${css.btnReset}`}
            onClick={() => setChosenCarId(null)}
          >
            <RxCross1 className={css.icon} />
          </button>
          <button
            type="button"
            onClick={handleChooseCar}
            className={`${css.btns} ${css.btnConfirm}`}
          >
            <SiTicktick className={css.icon} />
          </button>
        </div>
      )}
      <ul className={css.carList}>
        {cars?.map((car, index) => (
          <li key={car?.id ?? index} className={css.carListItem}>
            <div
              className={css.carIcon}
              style={{
                backgroundColor: getStableColor(
                  `${car?.make || ""}-${car?.plate || index}`
                ),
              }}
            >
              <IoCar className={css.carIconSvg} />
            </div>
            <div className={css.carInfoBox}>
              <p className={css.carPlate}>{car?.plate || "—"}</p>
              <p className={css.carMakeModel}>
                {[car?.make, car?.model].filter(Boolean).join(" ") || "—"}
              </p>
            </div>
            <label className={css.label} onClick={e => e.stopPropagation()}>
              <input
                type="radio"
                name="car"
                className={css.checkbox}
                checked={Number(chosenCarId) === Number(car?.id)}
                onChange={() => setChosenCarId(car?.id)}
              />
              <span className={css.cbMark}>
                <BsCheck className={css.cbIcon} />
              </span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
